export const colorRangeMapping = [
    {
        color: 'red',
        equals: 30
    },
    {
        color: 'red',
        after: 30
    }
];